import { render, staticRenderFns } from "./FreightTableExportModal.vue?vue&type=template&id=2452671a&scoped=true"
import script from "./FreightTableExportModal.vue?vue&type=script&lang=js"
export * from "./FreightTableExportModal.vue?vue&type=script&lang=js"
import style0 from "./FreightTableExportModal.vue?vue&type=style&index=0&id=2452671a&prod&scoped=true&lang=less"
import style1 from "./FreightTableExportModal.vue?vue&type=style&index=1&id=2452671a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2452671a",
  null
  
)

export default component.exports